import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { isEmpty, cloneDeep } from 'lodash';


import { KnBrCustomerContextService } from '../../../store/kn-br-customer-context/kn-br-customer-context.service';
import { KnBrCustomerService } from '../../../store/kn-br-customer/kn-br-customer.service';
import { CustomerData } from './../../../models/customer.model';
import { OccConfig, SiteContextParamsService, TranslatePipe } from '@spartacus/core';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { PaginationComponent, SpinnerComponent } from '@spartacus/storefront';
import { AsyncPipe } from '@angular/common';
import { RemoveLeadingZerosPipe } from '../../../shared/pipe/kn-br-custom-pipes/remove-leading-zeros.pipe';
import { KN_BR_CUSTOMER_CURRENT } from 'src/constants/api.endpoints.constant';

@Component({
    selector: 'knbr-customer-search-result',
    templateUrl: './kn-br-customer-search-result.component.html',
    styleUrls: ['./kn-br-customer-search-result.component.scss'],
    imports: [PaginationComponent, SpinnerComponent, AsyncPipe, TranslatePipe, RemoveLeadingZerosPipe]
})
export class KnBrCustomerSearchResultComponent implements OnInit, OnDestroy {
  customerSearchSubscription: any;
  customerResult$: Observable<CustomerData[]> = this.customerSearchService.list$;
  paginate$: Observable<any> = this.customerSearchService.paginate$;
  isLoading$: Observable<boolean> = this.customerSearchService.loading$;
  customerContext$: Observable<CustomerData> = this.customerContextService.get$;
  searchCriteria: any;
  routedFrom: string;
  copyObject: any;
  subscription: Subscription;
  customerNumber = '';
  selectedCustomer: CustomerData;
  constructor(
    private customerSearchService: KnBrCustomerService,
    private customerContextService: KnBrCustomerContextService,
    protected config: OccConfig,
    protected siteContextParamsService: SiteContextParamsService,
    private knbrCommonService: KnBrCommonService
  ) {
        this.customerContext$.subscribe((value) => {
            if (value) {
              this.selectedCustomer = value;
              this.customerNumber = this.selectedCustomer.customerNumber ?this.selectedCustomer.customerNumber : null;
            }
          })
         this.knbrCommonService.getBrandSalesShipToList(this.customerNumber || KN_BR_CUSTOMER_CURRENT);
  }

  ngOnInit(): void {
    this.subscription = this.customerSearchService.searchCriteria$.subscribe((response) => {
      this.searchCriteria = cloneDeep(response);
    });
  }

  storeInContext(customer: CustomerData) {
    const indexOfSite =  this.config.context.country.indexOf(customer.countryCode.toLowerCase())
    if(indexOfSite > -1) {
      const site = this.config.context.baseSite[indexOfSite];
      const currency = this.config.context.currency[indexOfSite];
      this.siteContextParamsService.setValue('baseSite', site);
      this.siteContextParamsService.setValue('currency',currency);
    }
    this.customerContextService.set(customer);
  }

  pageChange(page: number): void {
    if (this.searchCriteria) {
      this.searchCriteria.currentPage = page;
    }
    this.customerSearchService.search(this.searchCriteria);
  }

  formatState(state) {
    return this.knbrCommonService.formatState(state);
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    };

    // this.knbrCommonService.customersData$.subscribe(res => {
    //   if (isEmpty(res)) {
    //     this.knbrCommonService.getCustomersData();
    //   }
    // })
  }
}
